import React, { Fragment, useEffect, useRef, useState } from 'react';
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import { makeStyles } from '@material-ui/core/styles';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import TagBox from '../common/CustomTagBox';
import DateBox from '../common/CustomDateBox';
import TreeSelector from './TreeSelector';
import searchIcon from "../../images/ui-ic-search.svg"
import { Button } from '@material-ui/core';
import exportIcon from "../../images/export.svg"
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    root: {
        display: "grid",
        justifyContent: "space-between",
        width: "100%",
        rowGap: "0.75rem",
        gridTemplateColumns: "repeat(4, calc(100vw/4 - 4%)) 10%",
    },
    cases:{
        gridColumn: "1 / 5",
        display: "grid",
        gridTemplateColumns: "repeat(6, 1fr)",
        columnGap: "0.75rem"
    },
    swicth: {
        marginLeft: "1.25rem"
    },
    display: {
        display: "inline-block !important"
    },
    displayFilters: {
        display: "flex",
        flexDirection: "column"
    },
    labelSwicth: {
        fontSize: "0.75rem !important"
    },
});

export default function TableForm(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const { 
        datos,
        estados,
        provinces,
        defaultStartDate,
        entryChannels,
        subEstados,
        services,
        customers,
        suppliers,
        supplierServiceTypes,
        handleSupplierChange,
        handleSupplierServiceTypeChange
    } = props;
    const [filterKey, setFilterKey] = useState(0);
    const entryChannelTagbox = useRef(null);
    const stateTagbox = useRef(null);
    const subStateTagbox = useRef(null);
    const serviceTagbox = useRef(null);
    const premiumTagBox = useRef(null);
    const customerTagbox = useRef(null);
    const supplierTagbox = useRef(null);
    const supplierServiceTypeTagbox = useRef(null);
    const premiumOptions = [{description: "Sí", value: true}, {description:"No", value: false}]

    function showClearFilters() {
        return Boolean(
            datos.busquedaGeneral ||
            (datos.estado && datos.estado.length > 0) ||
            (datos.fechaInicio && datos.fechaInicio !== defaultStartDate) ||
            datos.fechaInicioHasta ||
            (datos.taxonomies && datos.taxonomies.length > 0) ||
            (datos.entryChannels && datos.entryChannels.length > 0) ||
            (datos.subEstados && datos.subEstados.length > 0) ||
            datos.premium !== null ||
            (datos.suppliers && datos.suppliers.length > 0) ||
            (datos.supplierServiceTypes && datos.supplierServiceTypes.length > 0) ||
            datos.customerCode
        );
    }

    function clearFunction() {
        setFilterKey((prev) => prev + 1);
        entryChannelTagbox.current?.instance?.reset();
        stateTagbox.current?.instance?.reset();
        subStateTagbox.current?.instance?.reset();
        premiumTagBox.current?.instance?.reset();
        serviceTagbox.current?.instance?.reset();
        customerTagbox.current?.instance?.reset();
        supplierTagbox.current?.instance?.reset();
        supplierServiceTypeTagbox.current?.instance?.reset();
        props.clearFilters();
    }

    useEffect(() => {

        const statesWithsubStates = Array.isArray(estados) ? estados.filter((e) => e.subStates?.length > 0 && datos.estado?.some((de) => de === e.stateId)) : []
        const reselectedSubStates = datos.subEstados?.filter((substate) => statesWithsubStates?.some(parentState => parentState.subStates?.some(parentSubstates => parentSubstates.subStateId === substate)))

        if (reselectedSubStates?.length === 0) {
            subStateTagbox.current?.instance?.option("value", [])
        }

    }, [datos.estado])

    return (
        <form key={filterKey} onSubmit={props.handleSubmit} className={classes.root}>
            {props.type !== "Itvs" && props.type !== "Casos" &&
                <div>
                    <TextBox
                        placeholder="Buscar..."
                        value={datos.busquedaGeneral}
                        mode="text"
                        onEnterKey={props.type == "Casos" ? props.handleSubmit : null}
                        onValueChange={props.handleInputChange}
                        valueChangeEvent="keyup">
                        <TextBoxButton
                            name="search"
                            location="after"
                            options={{
                                icon: searchIcon,
                                stylingMode: 'text',
                                onClick: (e) => {
                                    props.handleSubmit(e.event);
                                }
                            }}
                        />
                    </TextBox>
                </div>
            }
            {
                props.type == "Itvs" &&
                <Fragment>
                    <div>
                        <TextBox
                            label="Buscar..."
                            value={datos.busquedaGeneral}
                            mode="text"
                            onEnterKey={props.type == "Casos" ? props.handleSubmit : null}
                            onValueChange={props.handleInputChange}
                            valueChangeEvent="keyup">
                            <TextBoxButton
                                name="search"
                                location="after"
                                options={{
                                    icon: searchIcon,
                                    stylingMode: 'text',
                                    onClick: (e) => {
                                        props.handleSubmit(e.event);
                                    }
                                }}
                            />
                        </TextBox>
                    </div>
                    <div onKeyPress={props.checkEnter} className={classes.display}>
                        <div style={{ float: "left", width: 200, marginRight: 10, marginLeft: 10 }} className={classes.display}>
                            <TagBox id="custom-provinces"
                                className="tagStates"
                                label="Provincias"
                                searchEnabled={true}
                                style={{height: "3rem"}}
                                dataSource={provinces}
                                defaultValue={datos.provincias ? [].concat(datos.provincias) : []}
                                multiline={false}
                                onValueChanged={props.handleProvinceChange}
                                items={provinces}
                                showClearButton={true}>
                            </TagBox>
                        </div>
                    </div>
                </Fragment>
            }
            {
                props.type == "Casos" &&
                <Fragment>
                    <div>
                        <TextBox
                            label={`${t("Search")}...`}
                            value={datos.busquedaGeneral}
                            mode="text"
                            onEnterKey={props.type == "Casos" ? props.handleSubmit : null}
                            onValueChange={props.handleInputChange}
                            valueChangeEvent="keyup">
                                <TextBoxButton
                                    name="search"
                                    location="after"
                                    options={{
                                        icon: searchIcon,
                                        stylingMode: 'text',
                                        onClick: () => {
                                            props.handleSubmit();
                                        }
                                    }}
                                    />
                        </TextBox>
                    </div>
                    <div>
                        <DateBox
                            label={t("StartDateFrom")}
                            labelMode='static'
                            className="dateCases"
                            placeholder={t("StartDateFrom")}
                            useMaskBehavior={true}
                            inputAttr={{ 'aria-label': 'Date' }}
                            dateSerializationFormat="yyyy-MM-dd"
                            displayFormat="dd/MM/yyyy"
                            max={datos.fechaInicioHasta}
                            value={datos.fechaInicio}
                            onValueChanged={props.handleFechaIniChange}
                            onEnterKey={props.checkEnter}
                            type='date'
                            acceptCustomValue={false}
                            onContentReady={(e) => {
                                let parent = e.component._$textEditorInputContainer;
                                parent.children()[0].disabled = true;
                            }}
                            pickerType='calendar'
                            buttons={["dropDown"]}

                        >
                        </DateBox>
                    </div>
                    <div>
                        <DateBox
                            label={t("StartDateTo")}
                            labelMode='floating'
                            placeholder={t("StartDateTo")}
                            className="dateCases"
                            useMaskBehavior={true}
                            min={datos.fechaInicio}
                            value={datos.fechaInicioHasta}
                            dateSerializationFormat="yyyy-MM-dd"
                            displayFormat="dd/MM/yyyy"
                            type='date'
                            pickerType='calendar'
                            acceptCustomValue={false}
                            onContentReady={(e) => {
                                let parent = e.component._$textEditorInputContainer;
                                parent.children()[0].disabled = true;
                            }}
                            onEnterKey={props.checkEnter}
                            onValueChanged={props.handleFechaInicioHastaChange}>
                        </DateBox>
                    </div>
                    <div>
                        <TagBox id="custom-templates"
                            innerRef={entryChannelTagbox}
                            defaultValue={datos.entryChannels ? [].concat(datos.entryChannels) : []}
                            className="tagEntryChannel"
                            label={t("EntryChannel")}
                            labelMode='floating'
                            selectAllText={t("SelectAll")}
                            dataSource={entryChannels}
                            showSelectionControls={true}
                            multiline={false}
                            applyValueMode="instantly"
                            displayExpr="description"
                            onValueChanged={props.handleEntryChannelChange}
                            valueExpr="entryChannelId"
                            items={entryChannels}
                            showClearButton={true}>

                        </TagBox>
                    </div>
                    {/* <div>
                        <TagBox id="custom-templates"
                            innerRef={premiumTagBox}
                            defaultValue={datos.premium ? [].concat(datos.premium) : []}
                            className="tagPremium"
                            label="Premium"
                            labelMode='floating'
                            selectAllText="Selecionar todos"
                            dataSource={premiumOptions}
                            showSelectionControls={true}
                            multiline={false}
                            applyValueMode="instantly"
                            displayExpr="description"
                            onValueChanged={props.handlePremiumChange}
                            valueExpr="value"
                            showDropDownButton
                            dropDownOptions={{width:"fit-content"}}
                            items={premiumOptions}
                            showClearButton={true}              
                            >
                        </TagBox>
                    </div> */}
                    <div className={classes.cases}>
                        {/* <div>
                        {services && services?.length === 1 ?
                            <TextBox
                                label={t("Service")}
                                labelMode='floating'
                                readOnly
                                value={services[0].serviceName}
                            />
                            :
                            <TagBox id="custom-templates"
                                innerRef={serviceTagbox}
                                defaultValue={datos.servicios ? [].concat(datos.servicios) : []}
                                className="tagStates"
                                label={t("Services")}
                                labelMode='floating'
                                placeholder={t("Services")}
                                selectAllText={t("SelectAll")}
                                noDataText={t("NoDataToDisplay")}
                                dataSource={services}
                                showSelectionControls={true}
                                multiline={false}
                                applyValueMode="instantly"
                                displayExpr="serviceName"
                                onValueChanged={props.handleServiceChange}
                                valueExpr="serviceId"
                                showClearButton={true}>
                            </TagBox>
                            }
                        </div> */}
                        <div>
                            <TreeSelector services={datos.servicios} selectNodesRecursive={true} selectAllText={t("SelectAll")} taxonomies={datos.taxonomies} onSelectionChanged={props.handleTaxonomiesChange} ></TreeSelector>
                        </div>
                        <div>
                            <TagBox id="custom-templates"
                                innerRef={stateTagbox}
                                defaultValue={datos.estado ? [].concat(datos.estado) : []}
                                className="tagStates"
                                label={t("States")}
                                placeholder={t("States")}
                                labelMode='floating'
                                selectAllText="Selecionar todos"
                                dataSource={estados}
                                showSelectionControls={true}
                                multiline={false}
                                applyValueMode="instantly"
                                displayExpr="description"
                                onValueChanged={props.handleBoxChange}
                                valueExpr="stateId"
                                items={estados}
                                showClearButton={true}
                            >
                            </TagBox>
                        </div>
                        {/* <div>
                            <TagBox id="custom-templates"
                                innerRef={subStateTagbox}
                                defaultValue={datos.subEstados ? [].concat(datos.subEstados) : []}
                                className="tagStates"
                                label="Subestados"
                                placeholder="Subestados"
                                labelMode='floating'
                                selectAllText="Selecionar todos"
                                noDataText='No hay subestados'
                                dataSource={subEstados}
                                grouped={true}
                                showSelectionControls={true}
                                multiline={false}
                                applyValueMode="instantly"
                                displayExpr="description"
                                onValueChanged={props.handleSubStateChange}
                                valueExpr="subStateId"
                                showClearButton={true}>
                            </TagBox>
                        </div> */}
                        <div>
                            <TagBox 
                                id="customer-filter"
                                innerRef={customerTagbox}
                                label={t("Customer")}
                                dataSource={customers}
                                defaultValue={datos.customerCode ? (Array.isArray(datos.customerCode) ? datos.customerCode : datos.customerCode.split(",")) : []}
                                onValueChanged={props.handleCustomerChange}
                                searchEnabled={true}
                                displayExpr="customerName"
                                valueExpr="customerCode"
                                multiline={false}
                                applyValueMode="instantly"
                                labelMode='floating'
                                showClearButton={true}
                                showSelectionControls={true} 
                            />
                        </div>
                        <div>
                            <TagBox id="custom-suppliers"
                                innerRef={supplierTagbox}
                                defaultValue={datos.suppliers ? [].concat(datos.suppliers) : []}
                                className="tagStates"
                                label={t("Suppliers")}
                                placeholder={t("Suppliers")}
                                labelMode='floating'
                                selectAllText={t("SelectAll")}
                                dataSource={suppliers}
                                showSelectionControls={true}
                                multiline={false}
                                applyValueMode="instantly"
                                displayExpr="description"
                                valueExpr="supplierId"
                                onValueChanged={props.handleSupplierChange}
                                items={suppliers}
                                showClearButton={true}
                            />
                        </div>
                        <div>
                            <TagBox id="custom-supplier-service-types"
                                innerRef={supplierServiceTypeTagbox}
                                defaultValue={datos.supplierServiceTypes ? [].concat(datos.supplierServiceTypes) : []}
                                className="tagStates"
                                label={t("SupplierServiceTypes")}
                                placeholder={t("SupplierServiceTypes")}
                                labelMode='floating'
                                selectAllText={t("SelectAll")}
                                dataSource={supplierServiceTypes}
                                showSelectionControls={true}
                                multiline={false}
                                applyValueMode="instantly"
                                displayExpr="description"
                                valueExpr="supplierServiceTypeId"
                                onValueChanged={props.handleSupplierServiceTypeChange}
                                items={supplierServiceTypes}
                                showClearButton={true}
                            />
                        </div>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                            <Button color='primary' variant='contained' onClick={props.handleSubmit}>{t("ApplyFilters")}</Button>
                            {showClearFilters() &&
                                <div style={{ cursor: 'pointer', marginLeft: 30 }} className={classes.display}>
                                    <DeleteOutlinedIcon style={{ verticalAlign: 'middle', color: '#015BA8' }} onClick={clearFunction} />
                                </div>
                            }
                        </div>
                    </div>
                </Fragment>
            }
            {props.type !== "Itvs" &&
                <div style={{display: "flex", justifyContent: "flex-end", gridColumnStart: 5}}>
                    <Button
                        startIcon={<img style={{height: "1.25rem", width: "1.25rem"}} src={exportIcon}/>}
                        variant='outlined'
                        color='primary'
                        onClick={props.exportExcel}
                        disabled={props.loadingExport}
                    >
                        {t("Export")}
                    </Button>
                </div>
            }
        </form>
    )
}